import { Injectable } from '@angular/core';
import { TranslocoService, getBrowserLang } from '@ngneat/transloco';
import { AvailableLanguages } from 'src/assets/i18n/available-languages';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  constructor(public translate: TranslocoService) {
    this.loadLanguage();
  }

  /** Check localStorage for language, and if there isn't any, check browser language. */
  public loadLanguage() {
    const storedLang = localStorage.getItem('LOYAL_LANG');
    if (storedLang && AvailableLanguages.some((e) => e.lang === storedLang)) {
      // Use the stored language preference
      this.translate.setActiveLang(storedLang);
    } else {
      // TODO - uncomment when in more countries
      // this.checkBrowserLanguage();
      this.useLanguage('hr');
    }
  }

  public checkBrowserLanguage(): void {
    if (
      getBrowserLang() &&
      AvailableLanguages.some((e) => e.lang === getBrowserLang())
    ) {
      // Now that we have English translation, we can enable automatic language detection
      this.useLanguage(getBrowserLang());
      return;
    }
    this.useLanguage('hr');
  }

  /**
   * Sets the language for the app to use and saves it to LS
   * @param language The selected language
   */
  public useLanguage(language: string): void {
    this.translate.setActiveLang(language);
    localStorage.setItem('LOYAL_LANG', language);
  }
}
